import angular from 'angular'
import moment from 'moment-timezone'
import Papa from 'papaparse'

angular.module('admin.all_sales').controller('TransactionsCtrl', TransactionsCtrl)

/** @ngInject */
function TransactionsCtrl($scope, AllSalesService) {
  var vm = this
  vm.parent = $scope.$parent.vm
  vm.items = []

    // Date Picker state
    vm.date1 = new Date(new Date().getFullYear(), 0, 1)
    vm.date2 = ''

    vm.openCalendarStart = function (e) {
      e.preventDefault()
      e.stopPropagation()
      vm.isOpenStart = true
    }

    vm.openCalendarEnd = function (e) {
      e.preventDefault()
      e.stopPropagation()
      vm.isOpenEnd = true
    }

    // Filter Models
    vm.filters = {
      channels: [],
      bundleId: '',
      transactionType: 'all',
      transactionStatus: 'all',
    }

    vm.transactionTypes = [
      { id: 'all', name: 'All Types' },
      { id: 4, name: 'Free' },
      { id: 3, name: 'Paid' },
    ]

    vm.transactionStatuses = [
      { id: 'all', name: 'All Statuses' },
      { id: 2, name: 'Success' },
      { id: 0, name: 'Failed' },
      { id: 1, name: 'Pending' },
    ]

    // Export Modal State
    vm.selectAll = false
    vm.exportFields = [
      { id: 'transaction_id', name: 'Transaction ID', selected: true },
      { id: 'user', name: 'User', selected: true },
      { id: 'date', name: 'Date', selected: true },
      { id: 'channel_name', name: 'Channel Name', selected: true },
      { id: 'bundle_name,bundle_id', name: 'Pack', selected: true },
      { id: 'transaction_type', name: 'Transaction Type', selected: true },
      { id: 'status', name: 'Status', selected: true },
      { id: 'amount', name: 'Amount', selected: true },
    ]

    vm.toggleSelectAll = function () {
      angular.forEach(vm.exportFields, function (field) {
        field.selected = vm.selectAll
      })
    }

    vm.checkSelectAll = function () {
      var allSelected = true
      var anySelected = false
      angular.forEach(vm.exportFields, function (field) {
        if (!field.selected) {
          allSelected = false
        } else {
          anySelected = true
        }
      })
      vm.selectAll = allSelected
      vm.canExport = anySelected
    }

    vm.canExport = true
    vm.selectAll = true

    vm.openExportModal = function () {
      $('#exportModal').modal('show')
    }

    // Pagination config
    vm.perPage = 25
    vm.loading = false

    function reloadPagination() {
      vm.totalItems = 0
      vm.oldPage = 0
      vm.currentPage = 25
      vm.first = true
      vm.pagination = { current: 1 }
    }

    reloadPagination()

    vm.resetFilters = function () {
      vm.date1 = new Date(new Date().getFullYear(), 0, 1)
      vm.date2 = ''
      vm.filters.channels = []
      vm.filters.bundleId = ''
      vm.filters.transactionType = 'all'
      vm.filters.transactionStatus = 'all'
      vm.reload()
    }

    vm.reload = function () {
      reloadPagination()
      vm.load(1)
    }

    vm.load = function (pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1
      }

      if (!vm.first) {
        vm.currentPage = pageNumber * vm.perPage
        vm.oldPage = vm.currentPage - vm.perPage
      } else {
        vm.first = false
      }

      var payloadFilters = {
        startDate: vm.date1 ? Math.floor(moment(vm.date1).valueOf() / 1000) : null,
        endDate: vm.date2 ? Math.floor(moment(vm.date2).valueOf() / 1000) : null,
        channels: vm.filters.channels,
        bundleId: vm.filters.bundleId,
        transactionType: vm.filters.transactionType,
        transactionStatus: vm.filters.transactionStatus,
      }

      if (payloadFilters.startDate && payloadFilters.endDate && payloadFilters.startDate > payloadFilters.endDate) {
        swal('Invalid Date Range', 'End Date cannot be before Start Date.', 'warning')
        return
      }

      vm.loading = true
      vm.items = []

      AllSalesService.list(vm.oldPage, vm.perPage, payloadFilters)
        .then(function (result) {
          vm.loading = false
          if (vm.totalItems === 0) {
            vm.totalItems = result.ct
          }
          for (var i = 0; i < result.results.length; i++) {
            var itemDate = result.results[i].ts
            if (itemDate && itemDate.toString().length > 13) {
              itemDate = itemDate / 1000
            }
            result.results[i].parsedDate = new Date(itemDate)
          }
          vm.items = result.results
          $('html, body').scrollTop(0)
        })
        .catch(function (err) {
          vm.loading = false
          swal('Error', 'Failed to fetch transactions.', 'error')
        })
    }

    vm.pageChanged = function (newPage) {
      vm.load(newPage)
      $('html, body').animate({ scrollTop: 0 }, 0)
    }

    vm.export = function () {
      if (!vm.canExport) {
        swal('Error', 'Please select at least one field to export.', 'error')
        return
      }
      const selectedFields = vm.exportFields.filter((f) => f.selected).map((f) => f.id)
      vm.exportLoading = true

      var payloadFilters = {
        startDate: vm.date1 ? Math.floor(moment(vm.date1).valueOf() / 1000) : null,
        endDate: vm.date2 ? Math.floor(moment(vm.date2).valueOf() / 1000) : null,
        channels: vm.filters.channels,
        bundleId: vm.filters.bundleId,
        transactionType: vm.filters.transactionType,
        transactionStatus: vm.filters.transactionStatus,
      }

      AllSalesService.exportTransactions(payloadFilters, selectedFields)
        .then(function (result) {
          vm.exportLoading = false
          $('#exportModal').modal('hide')
          let csv = ''
          if (typeof result === 'string') {
            csv = result.replace(/\{\}\s*$/, '')
          } else {
            csv = Papa.unparse(result.results || result, { delimiter: ',', newline: '\n' })
          }
          if (!csv) return

          let dateString = moment().format('YYYY-MM-DD')
          let filename = 'transactions_' + dateString + '.csv'
          var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
          var url = window.URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = filename
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        })
        .catch(function (error) {
          vm.exportLoading = false
          swal('Error', 'Failed to export CSV. Please try again.', 'error')
        })
    }

    vm.getStatusLabel = function (status) {
      if (status === 2) return 'Success'
      if (status === 0) return 'Failed'
      if (status === 1) return 'Pending'
      return 'Unknown'
    }

    vm.getBadgeClass = function (status) {
      if (status === 2) return 'label-success'
      if (status === 0) return 'label-danger'
      if (status === 1) return 'label-warning'
      return 'label-default'
    }

    vm.load(1)
}
